import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/tourInfo', request)
}

export {get}
